const prefetchResultToBase64 = async (result: {
	uri: string | undefined;
	blob: Blob;
}): Promise<string> => {
	const { blob } = result;
	const reader = new FileReader();
	reader.readAsDataURL(blob);
	const base64 = await new Promise<string>((resolve, reject) => {
		reader.onloadend = () => {
			resolve(reader.result as string);
		};
		reader.onerror = reject;
	});
	const stripped = base64.replace(/^data:image\/[a-z]+;base64,/, "");
	return stripped;
};

export default prefetchResultToBase64;
